import React, { Component } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { Search as SearchIcon } from 'react-feather';
import { connect } from 'react-redux';
import PerPage from './PerPage';
import AddButton from './AddButton';
import * as Helpers from '../../../Utilities/Common';


class Search extends Component {
    constructor(props){
        super(props);
        this.state = { search: "" };
    }

    reset = () => {
        const { auth, getData } = this.props;
        getData(auth.token,false);
        this.setState((state) => ({search: ""}));
    }

    setField = (endpoint, option, type = 0) => {
        Helpers.setField(endpoint, option, type, (dataObj) => this.setState((state) => (dataObj)));
    }

    search = () => {
        const { search } = this.state;
        const { getData, auth } = this.props;
        getData(auth.token, {page: 1, text_filter: search},false);
    }

    render(){
        const { search } = this.state;
        const { endpoint, width="70%", getData, meta } = this.props;
        return (
            <div>
                <Row className="mb-4">
                    <Col xs="12">
                        <div className="d-flex flex-wrap">
                            <div className="m-1" style={{ minWidth:width }}>
                                <Input onChange={(value) => this.setField("search",value)} value={search} maxLength={40} placeholder="Search" /> 
                            </div>
                            <div className="m-1">
                                <Button color="success" onClick={this.search}><SearchIcon style={{ strokeWidth: "3px", verticalAlign: "text-bottom"}} size={18}/></Button>
                            </div>
                            <div className="m-1">
                                <AddButton type={endpoint} />
                            </div>
                            <div className="m-1">
                                <Button color="primary" onClick={this.reset}>Reset</Button>
                            </div>
                            <div className="m-1">
                                <PerPage fetch={getData} meta={meta}/>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(Search);


// WEBPACK FOOTER //
// ./src/Components/App/Layout/Search.js